"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Math_1 = require("../../util/Math");
const ConstrainedFloatingPoint_1 = require("../../util/types/ConstrainedFloatingPoint");
class NArmedBandit {
    constructor(numBandits, numArms, numSpins) {
        this.numBandits = numBandits;
        this.numArms = numArms;
        this.numSpins = numSpins;
        this.currentTurn = 0;
        this.currentTotalReward = 0;
        this.lastTurnReward = 0;
        this.lastArmChoice = 0;
        this.lastBandit = 0;
        this.banditConfig = Array.from({ length: this.numBandits }, () => Array.from({ length: this.numArms }, () => {
            const reward = (0, Math_1.round)(Math.random(), 3);
            // We want cost to be less than the reward:
            const cost = (0, Math_1.round)(reward * Math.random(), 3);
            return {
                threshold: (0, Math_1.round)(Math.random(), 3),
                reward,
                cost
            };
        }));
        this.turnBanditChoice = Array.from({ length: this.numSpins }, () => (Math.floor(Math.random() * this.numBandits)));
        this.turnBanditLuck = Array.from({ length: this.numSpins }, () => (0, Math_1.round)(Math.random(), 3));
    }
    getState() {
        return [
            // current state:
            this.currentBanditIdx,
            // Info about last action:
            this.lastTurnReward,
            this.lastArmChoice,
            this.lastBandit
        ];
    }
    // Returns array of size:
    // arms + bandits * 2 + 1
    getStateConstrained() {
        const oneHotCurrentBandit = Array.from({ length: this.numBandits }, (_, i) => ((0, ConstrainedFloatingPoint_1.asConstrainedFloatingPoint)(this.currentBanditIdx === i ? 1.0 : 0.0)));
        const oneHotLastArm = Array.from({ length: this.numArms }, (_, i) => ((0, ConstrainedFloatingPoint_1.asConstrainedFloatingPoint)(this.lastArmChoice === i ? 1.0 : 0.0)));
        const oneHotLastBandit = Array.from({ length: this.numBandits }, (_, i) => ((0, ConstrainedFloatingPoint_1.asConstrainedFloatingPoint)(this.lastBandit === i ? 1.0 : 0.0)));
        return [
            // current state:
            ...oneHotCurrentBandit,
            // last state:
            (0, ConstrainedFloatingPoint_1.asConstrainedFloatingPoint)(this.lastTurnReward),
            ...oneHotLastArm,
            ...oneHotLastBandit
        ];
    }
    get done() {
        return this.currentTurn >= this.numSpins - 3;
    }
    get currentBanditIdx() {
        return this.turnBanditChoice[this.currentTurn];
    }
    get currentBanditArms() {
        return this.banditConfig[this.currentBanditIdx];
    }
    get currentLuck() {
        return this.turnBanditLuck[this.currentTurn];
    }
    setAction(action) {
        // Take the bandit for this turn:
        const banditArms = this.currentBanditArms;
        // Grab the arm selected:
        const selectedArm = banditArms[action];
        // Grab our lucky number:
        const luck = this.currentLuck;
        // Did we pass the threshold?
        const winner = luck > selectedArm.threshold;
        const reward = winner ? selectedArm.reward : -1 * selectedArm.cost;
        // Update our state:
        this.lastTurnReward = reward;
        this.lastArmChoice = action;
        this.lastBandit = this.currentBanditIdx;
        this.currentTotalReward += reward;
        this.currentTurn += 1;
    }
    reset() {
        this.lastTurnReward = 0;
        this.lastArmChoice = 0;
        this.lastBandit = 0;
        this.currentTotalReward = 0;
        this.currentTurn = 0;
    }
}
exports.default = NArmedBandit;
